import React from 'react';

export default function Bar(props) {
  const { group, population, partially, fully, boosters } = props;
  console.log('props ', props);

  const fb = 3000000000;

  const noVaxStyle = {
    width: `${(population / fb) * 100}%`,
  };

  const singleBarStyle = {
    width: `${(partially / fb) * 100}%`,
  };

  const doubleBarStyle = {
    width: `${(fully / fb) * 100}%`,
  };

  const boosterBarStyle = {
    width: `${(boosters / fb) * 100}%`,
  };

  return (
    <div className="details-wrap">
      <div className="groupName">{group}</div>
      <div className="bar-wrap">
        <div className="no-vax" style={noVaxStyle} />
        <div className="single-bar" style={singleBarStyle} />
        <div className="double-bar" style={doubleBarStyle} />
        <div className="booster-bar" style={boosterBarStyle} />
      </div>
    </div>
  );
}
